// extracted by mini-css-extract-plugin
export var body = "_2x-1";
export var bodyPadded = "_2x-2";
export var chevron = "_2x-4";
export var chevronOpen = "_2x-5";
export var header = "_2x-0";
export var icon = "_2x-3";